import { IWishlist } from '@/hooks/useWishlists';
import { IRentalTile } from '@/utility/mapSearchResultToTile';

import { WishlistCard } from './WishlistCard';
import { WishlistsRecentlyViewedCard } from './WishlistsRecentlyViewedCard';

type TWishlistGridProps = {
  wishlists?: IWishlist[];
  recentlyViewedTiles?: IRentalTile[];
  editMode?: boolean;
  refetchWishlists?: () => void;
  isMobile?: boolean;
  rentalCategory: string;
};

export const WishlistGrid = ({
  wishlists = [],
  recentlyViewedTiles,
  editMode = false,
  refetchWishlists,
  isMobile = false,
  rentalCategory,
}: TWishlistGridProps) => {
  const haveRecentlyViewedTiles =
    isMobile || (recentlyViewedTiles && recentlyViewedTiles.length > 0);

  return (
    <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
      {haveRecentlyViewedTiles && (
        <WishlistsRecentlyViewedCard
          recentlyViewedTiles={recentlyViewedTiles}
          rentalCategory={rentalCategory}
        />
      )}

      {wishlists.map(wishlist => (
        <WishlistCard
          key={wishlist.id}
          wishlist={wishlist}
          editMode={editMode}
          refetchWishlists={refetchWishlists}
        />
      ))}
    </div>
  );
};
